import { Radio, RadioGroup} from "rsuite";
import MinCloseIcon from "@rsuite/icons/Close";
import ProhibitedIcon from '../../../img/prohibit_icon.svg';

import './regime_type.scss';
const RegimeType = (props) => {

    const {activeDiets} = props;
    const {disableDiets} = props;
    const {activeDiet} = props;
    const chosen = activeDiet?.id;
    return (<>
        {activeDiets && (
            <div className="regime-type" key="regime_type">
                <div key='options' className="options">
                    <div className="title  d-flex">
                    <span className="title-type">
                    رژیم مناسب برای رسیدن به وزن هدف انتخابی شما:

                    </span>
                    </div>
                    <div className="option-items radio-options">
                        {activeDiets && (<RadioGroup
                            name="regime-type"
                            value={chosen ?? null}
                            className="radio-group-flex">
                            {activeDiets?.map((type) => {

                                return <Radio
                                    className=""
                                    appearance="default"
                                    value={type.id}
                                    onChange={() => props.handleChange(type.id)}
                                    key={type.id}
                                    disabled={type.status===3}
                                >
                                    <div className= {`${chosen === type.id ?'checked-item' :''} option-content`}  >{type.title}</div>


                                </Radio>;
                            })}
                        </RadioGroup>)}
                    </div>
                </div>

                <div className="line"> </div>
                <div className="others " >
                    <div className="title d-flex">
                        <span>
                            سایر رژیم‌های چنگال
                        </span>
                    </div>
                    <div className=" option-items ">
                        {disableDiets?.map((type) => {
                            return (<>
                                <div className="d-flex flex-md-row ">
                                    <div className="icon"><img src={ProhibitedIcon}/></div>
                                    <div className="option-content">{type.title}</div>
                                </div>
                            </>)
                        })}
                    </div>
                </div>
            </div>
        )}
    </>)
}

export default RegimeType;
